import { CreateLegalClientLegalHeadParams } from 'api/types/params';
import { isGlobalProject } from 'config';
import {
  parseBaseStateRegistrationParam,
  parseCompanyAddressParam,
  parseCompanyTaxResidencyParam,
  parseStateRegistrationParam,
} from 'modules/client/common/helpers';
import { parseHeadPositionParam } from 'modules/client/common/helpers/parseParams/parseHeadPositionParam';
import { getOrganizationalAndLegalFormParam } from 'modules/client/legal/helpers/getLegalClientSubmitData/getOrganizationalAndLegalFormParam';

import { LegalClientLegalHeadFormType } from '../../forms/legalClientLegalHeadForm';

export const getLegalClientLegalHeadSubmitData = (
  legalClientId: string,
  versionNumber: number,
  values: LegalClientLegalHeadFormType
): CreateLegalClientLegalHeadParams => {
  const addressParam = parseCompanyAddressParam(values);
  const isGlobal = isGlobalProject();

  return {
    versionNumber,
    legalClientId,
    reason: values.reasonChange.reason,
    fullName: values.companyName.fullName,
    shortName: values.companyName.shortName,
    legalAddress: addressParam.legalAddress,
    actualAddress: addressParam.actualAddress,
    taxResidences: parseCompanyTaxResidencyParam(values),

    stateRegistration: isGlobal
      ? parseBaseStateRegistrationParam(values)
      : parseStateRegistrationParam(values),

    position: parseHeadPositionParam(values),

    organizationalAndLegalForm: isGlobal
      ? getOrganizationalAndLegalFormParam(values)
      : undefined,
  };
};
